import Tabla from "./tabla";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";

export default withRouter(withApollo(Tabla));
